import React, { memo, ReactElement } from 'react';
import PageTitle, { PageTitleProps } from './PageTitle';
import track from 'react-tracking';

export interface PageTitleWithTrackingProps extends PageTitleProps {
    gaTitle?: string;
}

function PageTitleWithTracking({ gaTitle, text, className }: PageTitleWithTrackingProps): ReactElement {
    const gaPageTitle = gaTitle ? gaTitle : text;

    const TrackedPage = track(
        {
            event: 'VirtualPageview',
            gaPageTitle,
        },
        { dispatchOnMount: true }
    )(PageTitle);

    return <TrackedPage text={text} className={className} />;
}

export default memo(PageTitleWithTracking);
